import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Global back-navigation button.
 *
 * Behavior:
 * 1. If the user came from another page in this tab (history length > 1)
 *    AND the previous location was inside our app → go back one step.
 * 2. Otherwise (deep-link, fresh tab, or top-level routes like /dashboard,
 *    /entities, /pricing) → fall back to /dashboard so the user is never stranded.
 *
 * Hidden on the dashboard root since there's nowhere to go back to.
 */
export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide on dashboard root — it's the home of the app
  if (location.pathname === '/dashboard' || location.pathname === '/') {
    return null;
  }

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <button
      onClick={handleBack}
      data-testid="global-back-btn"
      className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white px-3 py-1.5 rounded-lg hover:bg-slate-800 transition"
      aria-label="Go back"
    >
      <ArrowLeft className="w-4 h-4" />
      <span className="hidden sm:inline">Back</span>
    </button>
  );
}
